import foto1 from "../assets/img/vorstand/IMG_3471-removebg-preview.png";
import foto2 from "../assets/img/vorstand/IMG_3479-removebg-preview.png";
import foto3 from "../assets/img/vorstand/IMG_3482-removebg-preview.png";
import foto4 from "../assets/img/vorstand/IMG_3485-removebg-preview.png";
import foto5 from "../assets/img/vorstand/IMG_3489-removebg-preview.png";
import foto6 from "../assets/img/vorstand/IMG_3495-removebg-preview.png";
import foto7 from "../assets/img/vorstand/IMG_3512-removebg-preview.png";
import foto8 from "../assets/img/vorstand/WhatsApp_Image_2023-05-23_at_18.31.56-removebg-preview.png";
import foto9 from "../assets/img/vorstand/WhatsApp_Image_2023-05-23_at_18.43.50-removebg-preview.png";
import foto10 from "../assets/img/vorstand/WhatsApp_Image_2023-07-18_at_19.29.35-removebg-preview.png";
const vorstandData = [
  {
    img: foto3,
    name: "Timo Neuber",
    position: "1. Vorsitzender",
    tel: "01701796321",
    email: "dg-lichtenberg@gmx.de",
  },
  {
    img: foto5,
    name: "Christian Krüger",
    position: "2. Vorsitzender",
    tel: "",
    email: "",
  },
  {
    img: foto8,
    name: "Jan-Luca Kinzelmann",
    position: "Schriftführer",
    tel: "",
    email: "",
  },
  {
    img: foto6,
    name: "Verena Schneider",
    position: "Kassiererin",
    tel: "",
    email: "",
  },
  {
    img: foto1,
    name: "Gregor Düwel",
    position: "Beisitzer",
    tel: "",
    email: "",
  },
  {
    img: foto4,
    name: "Mareike Kirchhof",
    position: "Beisitzerin",
    tel: "",
    email: "",
  },
  {
    img: foto2,
    name: "Johannes Mauelshagen",
    position: "Beisitzer",
    tel: "",
    email: "",
  },
  {
    img: foto9,
    name: "Gabi Krüger",
    position: "Beisitzerin",
    tel: "",
    email: "",
  },
  {
    img: foto10,
    name: "Heiko Förtsch",
    position: "Beisitzer",
    tel: "",
    email: "",
  },
];

export default vorstandData;
